"use strict";

/*
 * ログイン画面
 */

import * as util from './util'

$(function () {

    if($("#h_logout_mode").val() == "logout"){
        history.replaceState('', '', '/');
        util.showInfoMessageLogout("ログアウトしました");
    }

    // ログイン画面 - LOGIN IDテキストボックスENTER処理
    $("#input_loginid").keypress( function ( e ) {
        if ( e.which == 13 ) {
            userLogin($(this));
        }
    });
    
    //パスワード - 眼のアイコン押下イベント
    $('.toggle_password').on('click', function() {
        const passwordInput = $('#input_password');
        const toggleIcon = $(this);

        if (passwordInput.attr('type') === 'password') {
            passwordInput.attr('type', 'text');
            toggleIcon.text('visibility'); // アイコンを「表示」に変更
          } else {
            passwordInput.attr('type', 'password');
            toggleIcon.text('visibility_off'); // アイコンを「非表示」に戻す
          }
    });

    // ログイン画面 - PASSWORDテキストボックスENTER処理
    $("#input_password").keypress( function ( e ) {
        if ( e.which == 13 ) {
            userLogin($(this));
        }
    });

    // ログイン画面 - LOGINボタン押下処理
    $("#btn_user_login").on("click", function(e){
        userLogin($(this));
    });
    
});

function userLogin(obj: any) {

    // ローカルストレージからシステムパラメータを取得
    let listDisplayedResults = localStorage.getItem("list_displayed_results");
    let mypageDisplayedResults = localStorage.getItem("mypage_displayed_results");
    let corporationsDisplayedResults = localStorage.getItem("corporations_displayed_results");

    let form = obj.parents("form");
    form.attr("action", obj.data("action"));
    $("<input>").attr({"type": "hidden", "name": "list_displayed_results", "value": listDisplayedResults}).appendTo(form);
    $("<input>").attr({"type": "hidden", "name": "mypage_displayed_results", "value": mypageDisplayedResults}).appendTo(form);
    $("<input>").attr({"type": "hidden", "name": "corporations_displayed_results", "value": corporationsDisplayedResults}).appendTo(form);
    form.submit();

}